angular.module('bmsApp.reports')
	.controller('ReportEmployeeAttendanceCtrl', [
		'$scope',
		function ($scope) {

			$scope.$watch(function () {
				return $scope.ReportIndex.selectedReport.reportData;
			}, function (value) {
				if (angular.isArray(value)) {
					angular.forEach(value, function (week) {
						// calculate attendance day totals
						var firstWeekEmployee = week[0];
						firstWeekEmployee[0].total_week_attendance_time_mins = 0;
						// calculate employee week totals
						angular.forEach(week, function (employee) {
							var totalAttendanceTimeMins = 0;
							var totalCleanTimeMins = 0;
							var totalTravelTimeMins = 0;
							angular.forEach(employee, function (day, dayIndex) {
								// add to attendance day total
								firstWeekEmployee[dayIndex].total_day_attendance_time_mins = firstWeekEmployee[dayIndex].total_day_attendance_time_mins || 0;
								firstWeekEmployee[dayIndex].total_day_attendance_time_mins += parseFloat(day.attendance_time_mins);
								firstWeekEmployee[0].total_week_attendance_time_mins += parseFloat(day.attendance_time_mins);
								// add to weekly total
								totalAttendanceTimeMins += parseFloat(day.attendance_time_mins);
								totalCleanTimeMins += parseFloat(day.clean_time_mins);
								totalTravelTimeMins += parseFloat(day.travel_time_mins);
							});
							// not the ideal place to store this, but convenient for now
							employee[0].total_attendance_time_mins = totalAttendanceTimeMins;
							employee[0].total_clean_time_mins = totalCleanTimeMins;
							employee[0].total_travel_time_mins = totalTravelTimeMins;
						});
					});
				}
			});

		}
	]);
